module.exports = __webpack_public_path__ + "static/media/calendarIcon.cd93267e.svg";